import { createSlice } from '@reduxjs/toolkit';
import { buildingType } from './types.ts';
import { fetchBuildings } from '../api/fetchKnowledge.ts';

interface KnowledgeState {
  data: buildingType[] | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: KnowledgeState = {
  data: null,
  isLoading: false,
  error: null,
};

const knowledgeSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBuildings.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBuildings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchBuildings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Неизвестная ошибка';
      });
  },
});

export default knowledgeSlice.reducer;
